// extracted by mini-css-extract-plugin
module.exports = {"scrollbar":"assignLiveSession_scrollbar__3CkxC","date":"assignLiveSession_date__38ZMZ"};